// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"back-button_BackButton__AwDBd","BackButtonRight":"back-button_BackButtonRight__1Na2w","BackButtonLeft":"back-button_BackButtonLeft__3oqS8"};